import { useEffect, useState, forwardRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Slide,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MarkPaidDialog = ({ open, close, invoiceId }) => {
  const [amountPaidInput, setAmountPaidInput] = useState("");
  const [paymentMethodUsed, setPaymentMethodUsed] = useState("card");

  const handleMarkPaid = async () => {
    const payload = {
      invoiceId,
      amountPaid: amountPaidInput,
      method: paymentMethodUsed,
    };
    const result = await request(`contracts/invoice/markpaid`, "post", payload);
    if (result.success) {
      toast.success("Payment logged successfully");
      setAmountPaidInput("");
      close();
    }
  };

  return (
    <Dialog open={open} onClose={() => close(false)}>
      <DialogTitle>Mark as Paid</DialogTitle>
      <DialogContent>
        <TextField
          label="Amount Paid"
          fullWidth
          type="number"
          value={amountPaidInput}
          onChange={(e) => setAmountPaidInput(e.target.value)}
          sx={{ mt: 2 }}
        />
        <Select
          fullWidth
          size="small"
          value={paymentMethodUsed}
          onChange={(e) => setPaymentMethodUsed(e.target.value)}
          sx={{ mt: 2 }}
        >
          <MenuItem value="card">Card</MenuItem>
          <MenuItem value="us_bank_account">ACH</MenuItem>
          <MenuItem value="zelle">Zelle</MenuItem>
        </Select>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button onClick={handleMarkPaid} variant="contained">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MarkPaidDialog;
